import { IState } from '../../store';
import { abUseExperimentsSelector, isAbUseExperimentsActive } from '../abUseExperiments';

export const MY_HOME_TRAP_BANNER_EXPERIMENT = 'valuation_my_home_cold_traps_ko_web';

export const selectIsMyHomeTrapBannerActive = (state: IState) => {
  const experiments = abUseExperimentsSelector(state);
  // эксперимент нацелен на группу = B
  const bGroup = isAbUseExperimentsActive(experiments, MY_HOME_TRAP_BANNER_EXPERIMENT, 'B');

  return bGroup;
};
